import {
    createTag,
    GetItemCounts,
    TagUpdateType,
    useInfiniteTags,
    useUpdateTags
} from "@twigsby/client-data";
import {DisplayTagType, SelectItemType} from "@twigsby/frontend-framework";
import {FilterUniqueArrayEntries} from "@twigsby/helpers";
import {useEffect, useState} from "react";
import {ShapeTagSelectData} from "../Components/Tags/TagHelpers";

const useTagManger = () => {
    const {
        status: tagStatus,
        data: tagData,
        error: tagError,
        isFetchingNextPage: isFetchingNextTagPage,
        fetchNextPage: fetchNextTagPage,
        hasNextPage: hasNextTagPage
    } = useInfiniteTags();

    const updateTags = useUpdateTags();

    const [ selectionTags, setSelectionTags ] = useState<any>(null);
    const [ selectionIndeterminateTags, setSelectionIndeterminateTags ] = useState<any>(null);

    const [ selectShapedData, setSelectShapedData ] = useState<Array<SelectItemType>>([]);

    const [ tagItemCounts, setTagItemCounts] = useState<any>({ loaded: 0, total: 0 } );

    const CreateTag = (value: any) => {
        return createTag(value).then((r) => {
            if(r) {
                updateTags.mutate({
                    newData: r,
                    tagIds: [r.id],
                    updateType: TagUpdateType.CREATE
                });

                return r;
            }
        });
    }

    const FilterTags = (mailData: any, selected: Array<any>, toggleAll?: boolean) => {
        let tagsSelected: Array<any> = [];

        if(mailData || toggleAll === false) {
            if(mailData?.pages) {
                mailData?.pages?.forEach((group: any) =>
                    group.data.forEach((item: any) => {
                        if (selected.includes(item.mailUuid) && item.tags) {
                            item.tags.forEach((tag: DisplayTagType) => {
                                tagsSelected.push(tag.id);
                            })
                        }
                    })
                )
            } else if (mailData?.data) {
                mailData?.data.forEach((item: any) => {
                    if (selected.includes(item.mailUuid) && item.tags) {
                        item.tags.forEach((tag: DisplayTagType) => {
                            tagsSelected.push(tag.id);
                        })
                    }
                })
            } else {
                mailData?.tags?.forEach((tag: DisplayTagType) => {
                    tagsSelected.push(tag.id);
                })
            }

            if(selected.length === 1) {
                tagsSelected = FilterUniqueArrayEntries(tagsSelected);
            }

            const counts: Map<string, number> = tagsSelected.reduce((acc, e) => acc.set(e, (acc.get(e) || 0) + 1), new Map());

            let selectedTags: Array<any> = [];
            let indeterminateTags: Array<any> = [];

            // @ts-ignore
            for (let [key, value] of counts) {
                if (value === selected.length) {
                    selectedTags.push(key);
                } else {
                    indeterminateTags.push(key);
                }
            }

            selectedTags = FilterUniqueArrayEntries(selectedTags);
            indeterminateTags = FilterUniqueArrayEntries(indeterminateTags);

            setSelectionTags(selectedTags);
            setSelectionIndeterminateTags(indeterminateTags);
        } else {
            setSelectionTags(null);
        }
    };

    const ShapeData = (tagData: any) => {
        setTagItemCounts(GetItemCounts(tagData as any));
        setSelectShapedData(ShapeTagSelectData(tagData));
    }

    useEffect(() => {
        if(tagData) {
            ShapeData(tagData);
        }
    }, [tagData]);

    return { tagItemCounts, selectShapedData, selectionTags, selectionIndeterminateTags, tagStatus, tagError, hasNextTagPage, fetchNextTagPage, isFetchingNextTagPage, CreateTag, FilterTags }
}

export default useTagManger
